import { useQuery, useLazyQuery, useMutation } from "@apollo/client/react"; import { useEffect, useState, useMemo } from 'react';
import { useTheme, useMediaQuery } from '@mui/material';

import { Box, Grid, IconButton, Pagination, Stack } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';
import { RenderInputByTypeMobile } from '../../../components/formGroupGenerator/RenderInputByTypeMobile';
import DELETE_JUSTIFICACION_VISITA from '../../../data/graphQL/mutations/ControlVisita/deleteJustificacionVisita';
import CREATE_JUSTIFICACIONES_VISITA from '../../../data/graphQL/mutations/ControlVisita/createJustificacionesVisita';
import GET_FECHAS_PERMITIDAS_JUSTIFICACION from '../../../data/graphQL/queries/ControlVisitas/getFechasPermitidasJustificacion';
import GET_JUSTIFICACIONES_VISITA, { adapterJustificaciones } from '../../../data/graphQL/queries/ControlVisitas/getJustificacionesVisita';
import { GET_COMBO_VISITA_VALOR, adaptCombosVisitas } from "../../../data/graphQL/queries/MisVisitas/getCombosVisitaValor";
import { mergeJustificaciones } from '../constants/mergeJustificaciones';
import toast from 'react-hot-toast';
import moment from 'moment';

const ID_COMBO_JUSTIFICACION = 20;

export const JustificacionesModal = ({ idEvaluacion, idProfesional, visitasAJustificar, handleSearch, readOnly = false }) => {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const [allowedDates, setAllowedDates] = useState([]);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;
  const [justificaciones, setJustificaciones] = useState([]);
  const [justificacionesCargadas, setJustificacionesCargadas] = useState([]);

  const [motivosOptions, setMotivosOptions] = useState([]);

  const [getAllowedDates, { data: dataAllowedDates }] = useLazyQuery(GET_FECHAS_PERMITIDAS_JUSTIFICACION, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataAllowedDates) return;
    setAllowedDates(dataAllowedDates?.allowedDatesJustificacion);
  }, [dataAllowedDates]);

  const [getJustificacionesCargadas, { data: dataJustificacionesCargadas }] = useLazyQuery(GET_JUSTIFICACIONES_VISITA, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataJustificacionesCargadas) return;
    const adapted = adapterJustificaciones(dataJustificacionesCargadas);
    setJustificacionesCargadas(adapted);
  }, [dataJustificacionesCargadas]);

  const { data: dataComboVisitaValor } = useQuery(GET_COMBO_VISITA_VALOR, {
    variables: { idComboVisita: ID_COMBO_JUSTIFICACION }
  });

  useEffect(() => {
    if (!dataComboVisitaValor) return;
    setMotivosOptions(adaptCombosVisitas(dataComboVisitaValor));
  }, [dataComboVisitaValor]);

  const [deleteJustificacion] = useMutation(DELETE_JUSTIFICACION_VISITA, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      handleSearch();
    }
  });

  const [createJustificaciones] = useMutation(CREATE_JUSTIFICACIONES_VISITA, {
    fetchPolicy: 'no-cache',
    onCompleted: () => {
      handleSearch();
    }
  });

  useEffect(() => {
    if (!idEvaluacion || !idProfesional) return;
    getAllowedDates({ variables: { idEvaluacion, idProfesional } });
    getJustificacionesCargadas({ variables: { idEvaluacion, idProfesional } });
  }, [idEvaluacion, idProfesional]);

  useEffect(() => {
    if ((!visitasAJustificar || visitasAJustificar === 0) && justificacionesCargadas.length > 0)
      setJustificaciones(justificacionesCargadas); else
      if (visitasAJustificar && visitasAJustificar > 0)
        setJustificaciones(mergeJustificaciones(justificacionesCargadas, visitasAJustificar)); else

        setJustificaciones([]);
  }, [justificacionesCargadas, visitasAJustificar]);

  const handleDeleteJustificacion = async (idBase) => {
    if (!idBase) return;
    toast.promise(deleteJustificacion({ variables: { idJustificacionVisita: idBase } }), {
      loading: 'Eliminando justificación...',
      success: 'Justificación eliminada.',
      error: 'Ocurrió un error al intentar eliminar la justificación.'
    });
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleAccept = () => {
    const justificacionesToCreate = justificaciones.
      filter((j) => !j.idBase && !!j.idComboVisitaValorMotivoJustificacion && !!j.fechaVisita).
      map((j) => ({
        idEvaluacion,
        idProfesional,
        idComboVisitaValorMotivoJustificacion: j.idComboVisitaValorMotivoJustificacion,
        fechaVisita: j.fechaVisita,
        observacion: j.observacion
      }));

    // if (justificacionesToCreate.some(j => !j.idComboVisitaValorMotivoJustificacion || !j.fechaVisita)) {
    //     toast.error('Por favor, completa todos los campos de las justificaciones antes de guardar.');
    //     return;
    // }

    if (justificacionesToCreate.length > 0) {
      toast.promise(createJustificaciones({ variables: { input: justificacionesToCreate } }), {
        loading: 'Guardando justificaciones...',
        success: 'Justificaciones guardadas.',
        error: 'Ocurrió un error al intentar guardar las justificaciones.'
      });
    }

    handleCloseModal();
  };

  const handleDelete = (id) => {
    const realId = justificaciones.find((j) => j.id === id)?.idBase;
    if (!!realId) {
      handleDeleteJustificacion(realId);
      setJustificaciones((prev) => prev.filter((j) => j.id !== id));
    } else {
      setJustificaciones((prevJustificaciones) =>
        prevJustificaciones.map((justificacion) => {
          if (justificacion.id === id) {
            return {
              ...justificacion,
              idComboVisitaValorMotivoJustificacion: null,
              fechaVisita: null,
              observacion: ''
            };
          }
          return justificacion;
        }));
    }
  };

  const handleChange = (id, name, value) => {
    setJustificaciones((prevJustificaciones) =>
      prevJustificaciones.map((justificacion) => {
        if (justificacion.id === id) {
          return { ...justificacion, [name]: value };
        }
        return justificacion;
      })
    );
  };

  const isDisabled = (fechaAlta) => {
    if (!fechaAlta) return false;
    const fecha = moment(fechaAlta).add(1, 'days');
    const hoy = moment();
    return fecha < hoy;
  };

  // paginación
  const paginated = useMemo(() =>
    justificaciones.slice((page - 1) * rowsPerPage, page * rowsPerPage),
    [justificaciones, page, rowsPerPage]);

  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <>
      <div aria-hidden='true' onClick={() => handleOpenModal()} className='item-option clickable-option'>
        <EditIcon className='edit-icon' />
        <span className='toggle-action'>Justificar</span>
      </div>
      <CustomDialog
        maxWidth="md"
        fullWidth={true}
        open={openModal}
        title={'Justificación de Visitas incumplidas'}
        onCancel={handleCloseModal}
        onAccept={!readOnly ? handleAccept : null}
        acceptText='Justificar'
        cancelText='Cerrar'>

        <Stack spacing={2}>
          {paginated.map((justificacion, index) =>
            <Box
              key={justificacion.id}
              sx={{
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                p: 2,
                backgroundColor: '#fafafa'
              }}>

              <Grid container item size={{ xs: 12 }} spacing={2}>
                {isMobile && <Grid item size={{ xs: 11, sm: 11, md: 0 }}></Grid>}
                <Grid item size={{ xs: 1, sm: 1, md: 1 }} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {!readOnly &&
                    <IconButton disabled={isDisabled(justificacion?.fechaAlta)} onClick={() => handleDelete(justificacion.id)}>
                      <DeleteIcon className='edit-icon' />
                    </IconButton>
                  }
                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                  <RenderInputByTypeMobile
                    input={{
                      name: 'idComboVisitaValorMotivoJustificacion',
                      type: 'select',
                      options: motivosOptions,
                      displayName: 'Motivo',
                      disabled: !!justificacion?.idBase || readOnly
                    }}
                    value={justificacion?.idComboVisitaValorMotivoJustificacion}
                    handleChange={(name, value) => handleChange(justificacion?.id, name, value)} />

                </Grid>
                <Grid item size={{ xs: 12, sm: 6, md: 3 }}>
                  <RenderInputByTypeMobile
                    input={{
                      allowedDates: !!justificacion?.idBase ? [] : allowedDates,
                      name: 'fechaVisita',
                      type: 'date',
                      displayName: 'Fecha de Visita',
                      disabled: !!justificacion?.idBase || readOnly,
                      disableFuture: true
                    }}
                    value={justificacion?.fechaVisita}
                    handleChange={(name, value) => handleChange(justificacion?.id, name, value)} />

                </Grid>
                <Grid item size={{ xs: 12, sm: 12, md: 5 }}>
                  <RenderInputByTypeMobile
                    input={{
                      name: 'observacion',
                      type: 'string',
                      displayName: 'Justificación',
                      disabled: !!justificacion?.idBase || readOnly
                    }}
                    value={justificacion?.observacion}
                    handleChange={(name, value) => handleChange(justificacion?.id, name, value)} />

                </Grid>
              </Grid>
            </Box>
          )}
          {justificaciones.length > rowsPerPage &&
            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Pagination
                count={Math.ceil(justificaciones.length / rowsPerPage)}
                page={page}
                onChange={(e, value) => setPage(value)}
                size="small"
                siblingCount={0}
                boundaryCount={1}
                showFirstButton
                showLastButton />

            </Box>
          }
        </Stack>
      </CustomDialog>
    </>);

};